module.exports = __webpack_public_path__ + "static/img/22.d82ddd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avtar/22.jpg
// module id = sDxD
// module chunks = 0